/* Gaveta do carrinho (replica da cart-drawer Dawn do concorrente, sections/cl-cart-drawer.liquid).
   - abre no icone do carrinho (#cart-icon-bubble / a[href="/cart"]) e ao adicionar produto;
   - intercepta TODO form de /cart/add em CAPTURA (inclusive o do buy_buttons nativo) antes do JS do tema;
     se o widget de kit (cl-kaching.js) deixou linhas em window.__clKachingLines, elas vao no lugar do form;
   - +/-/remover via /cart/change.js; o HTML volta pela Section Rendering API (?sections=cl-cart-drawer). */
(function () {
  'use strict';
  var SEC = 'cl-cart-drawer', OPEN = false;
  function root() { return document.getElementById('ClCartDrawer'); }
  function drawer() { var r = root(); return r && r.querySelector('cld-cart-drawer'); }

  function bubble(count) {
    document.querySelectorAll('#cart-icon-bubble').forEach(function (b) {
      var c = b.querySelector('.cart-count-bubble');
      if (!count) { if (c) c.remove(); return; }
      if (!c) { c = document.createElement('div'); c.className = 'cart-count-bubble'; b.appendChild(c); }
      c.innerHTML = '<span aria-hidden="true">' + count + '</span><span class="visually-hidden">' + count + ' items</span>';
    });
  }

  function swap(htmlText) {
    var r = root(); if (!r) return;
    var doc = new DOMParser().parseFromString(htmlText, 'text/html');
    var nr = doc.getElementById('ClCartDrawer'); if (!nr) return;
    var wasOpen = OPEN;
    var nd = nr.querySelector('cld-cart-drawer'), od = drawer();
    if (nd && od) {
      if (wasOpen) { nd.classList.add('cld-animate', 'cld-active'); }
      od.replaceWith(nd);
    }
  }
  function refresh() {
    var r = root(); if (r) r.classList.add('is-loading');
    return fetch(window.location.pathname + '?sections=' + SEC, { credentials: 'same-origin' })
      .then(function (x) { return x.json(); })
      .then(function (j) { if (j && j[SEC]) swap(j[SEC]); return fetch('/cart.js', { headers: { Accept: 'application/json' } }); })
      .then(function (x) { return x.json(); })
      .then(function (c) { bubble(c.item_count); if (r) r.classList.remove('is-loading'); return c; })
      .catch(function () { if (r) r.classList.remove('is-loading'); });
  }
  function isOpen() { return OPEN; }
  function open() {
    var d = drawer(); if (!d) return false;
    OPEN = true;
    root().setAttribute('aria-hidden', 'false');
    d.classList.add('cld-animate');
    // o re-render (?sections=) pode trocar o elemento antes do proximo quadro: a classe vai no ATUAL
    requestAnimationFrame(function () { if (OPEN) { var c = drawer(); if (c) c.classList.add('cld-active'); } });
    document.documentElement.classList.add('cl-cart-lock');
    return true;
  }
  function close() {
    var d = drawer(); OPEN = false; if (!d) return;
    d.classList.remove('cld-active');
    root().setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('cl-cart-lock');
  }
  function change(line, q) {
    var r = root(); if (r) r.classList.add('is-loading');
    return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: Math.max(0, q) }) })
      .then(function () { return refresh(); });
  }
  function add(body, isJson) {
    return fetch('/cart/add.js', { method: 'POST', headers: isJson ? { 'Content-Type': 'application/json', Accept: 'application/json' } : { Accept: 'application/json' }, body: body })
      .then(function (x) { return x.json().then(function (j) { if (!x.ok) throw j; return j; }); });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!root()) return;
    if (t.closest('[data-cl-cart-close]') || (t.closest('#ClCartDrawer') && t.closest('.cld-cart-drawer__overlay'))) {
      if (t.closest('a[href]') && !t.closest('[data-cl-cart-close][href]')) return;
      e.preventDefault(); close(); return;
    }
    var icon = t.closest('#cart-icon-bubble, a[href="/cart"]');
    if (icon && !t.closest('#ClCartDrawer')) {
      e.preventDefault();
      open(); refresh();
      return;
    }
    var qb = t.closest('#ClCartDrawer .cld-quantity__button');
    if (qb) {
      e.preventDefault();
      var inp = qb.parentElement.querySelector('input'), line = +inp.getAttribute('data-index');
      var q = (+inp.value || 0) + (qb.name === 'plus' ? 1 : -1);
      inp.value = Math.max(0, q); change(line, q); return;
    }
    var rm = t.closest('#ClCartDrawer cld-cart-remove-button');
    if (rm) { e.preventDefault(); change(+rm.getAttribute('data-index'), 0); }
  });
  document.addEventListener('change', function (e) {
    var inp = e.target.closest('#ClCartDrawer .cld-quantity__input'); if (!inp) return;
    change(+inp.getAttribute('data-index'), +inp.value || 0);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && isOpen()) close(); });

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !root() || !/\/cart\/add/.test(f.getAttribute('action') || '')) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var btn = f.querySelector('[type="submit"]') || document.querySelector('[form="' + f.getAttribute('id') + '"][type="submit"]');
    if (btn) btn.setAttribute('aria-busy', 'true');
    var lines = window.__clKachingLines || (window.clKachingLinesFor ? window.clKachingLinesFor(f.getAttribute('id') || '') : null), p;
    // "Best Travel Bundle" (dbtfy upsell bundles): um id[] por item marcado + cupom do bundle
    var multi = Array.prototype.filter.call(f.elements, function (el) { return el.name === 'id[]'; });
    var code = null;
    if (!lines && multi.length) {
      var box = f.closest('cl-dbtfy-upsell-bundles');
      lines = multi.filter(function (el) {
        var it = el.closest('.dbtfy-upsell-bundles__item'), cb = it && it.querySelector('.dbtfy-upsell-product-item__checkbox');
        return !cb || cb.checked;
      }).map(function (el) { return { id: +el.value, quantity: 1 }; });
      code = box && box.getAttribute('data-discount-name');
    }
    window.__clKachingLines = null;
    if (lines && lines.length) p = add(JSON.stringify({ items: lines }), true);
    else p = add(new FormData(f), false);
    p.then(function () { return code ? fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' }).catch(function () {}) : null; })
      .then(function () { open(); return refresh(); })
      .catch(function (err) { if (err && err.description) alert(err.description); })
      .then(function () { if (btn) btn.removeAttribute('aria-busy'); });
  }, true);

  window.clCart = { open: function () { open(); return refresh(); }, close: close, refresh: refresh };
})();
